import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';
import { getOktaStats } from '../services/oktaService';
import './Dashboard.css';
import API_URL from '../config';

const Dashboard = () => {
  const { user, token } = useAuth();
  const [stats, setStats] = useState(null);
  const [platformUserCount, setPlatformUserCount] = useState('—');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const oktaStats = await getOktaStats(token);
        setStats(oktaStats);

        const res = await fetch(`${API_URL}/platform-users`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const platformUsers = await res.json();
        setPlatformUserCount(platformUsers.length);
      } catch (err) {
        console.error('Failed to fetch stats:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [token]);

  const metrics = [
    { label: 'Okta Users', value: loading ? '...' : stats?.totalUsers ?? '—', sub: `${stats?.activeUsers ?? 0} active`, color: '' },
    { label: 'Active Groups', value: loading ? '...' : stats?.totalGroups ?? '—', sub: 'Okta groups', color: 'green' },
    { label: 'Apps Configured', value: loading ? '...' : stats?.totalApps ?? '—', sub: 'Connected apps', color: 'purple' },
    { label: 'Pending Reviews', value: '0', sub: 'Awaiting certification', color: 'orange' },
    { label: 'SoD Violations', value: '0', sub: 'Conflicts detected', color: 'red' },
    { label: 'Platform Users', value: loading ? '...' : platformUserCount, sub: 'OktaGuardian accounts', color: 'teal' },
  ];

  const recentActivity = [
    { action: 'Okta tenant connected successfully', time: 'Today' },
    { action: 'ABC Corp groups seeded in Okta', time: 'Today' },
    { action: 'ABC Corp users provisioned in Okta', time: 'Today' },
    { action: 'OktaGuardian platform initialised', time: 'Today' },
  ];

  return (
    <Layout>
      <div className="dashboard-header">
        <h1>Welcome, {user?.full_name}</h1>
        <p>ABC Corp Identity Governance Platform — Role: <strong>{user?.role}</strong></p>
      </div>

      <div className="metrics-grid">
        {metrics.map((metric, index) => (
          <div key={index} className={`metric-card ${metric.color}`}>
            <div className="metric-label">{metric.label}</div>
            <div className="metric-value">{metric.value}</div>
            <div className="metric-sub">{metric.sub}</div>
          </div>
        ))}
      </div>

      <div className="dashboard-section">
        <h2>Recent Activity</h2>
        {recentActivity.map((item, index) => (
          <div key={index} className="activity-item">
            <span className="activity-action">{item.action}</span>
            <span className="activity-time">{item.time}</span>
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default Dashboard;